'use client';

import { FindingsRenderer, type Finding } from '../../tools/finding';
import type { ParsedFinding } from '../types';
import type { OnOpenChatObject } from '../../hitl-types';

type FindingsSearchRendererProps = {
  findings: ParsedFinding[];
  query?: string;
  totalResults?: number;
  scoreThreshold?: number;
  maxHeight?: string;
  onOpenObject?: OnOpenChatObject;
};

/**
 * FindingsSearchRenderer - now uses the unified FindingsRenderer
 * with search metadata support
 */
export function FindingsSearchRenderer({
  findings,
  query,
  totalResults,
  scoreThreshold,
  maxHeight = '400px',
  onOpenObject,
}: FindingsSearchRendererProps) {
  // Convert ParsedFinding to Finding type
  const unifiedFindings: Finding[] = findings.map((finding) => ({
    findingId: finding.findingId,
    findingTitle: finding.findingTitle,
    severity: finding.severity,
    category: finding.category,
    content: finding.content,
    score: finding.score,
    rank: finding.rank,
  }));

  return (
    <FindingsRenderer
      findings={unifiedFindings}
      maxHeight={maxHeight}
      variant="compact"
      query={query}
      totalResults={totalResults}
      scoreThreshold={scoreThreshold}
      onOpenObject={onOpenObject}
    />
  );
}
